import axios from 'axios';
import { setAlert } from './alert';

// Action types
export const GET_MACHINES = 'GET_MACHINES';
export const GET_MACHINE = 'GET_MACHINE';
export const ADD_MACHINE = 'ADD_MACHINE';
export const UPDATE_MACHINE = 'UPDATE_MACHINE';
export const DELETE_MACHINE = 'DELETE_MACHINE';
export const SET_LOADING_MACHINE = 'SET_LOADING_MACHINE';
export const MACHINE_ERROR = 'MACHINE_ERROR';
export const SET_DELETE_MACHINE_ID = 'SET_DELETE_MACHINE_ID';
export const SET_UPDATE_MACHINE_ID = 'SET_UPDATE_MACHINE_ID';
export const REMOVE_DELETE_MACHINE = 'REMOVE_DELETE_MACHINE';
export const REMOVE_UPDATE_MACHINE = 'REMOVE_UPDATE_MACHINE';

// Get machines with pagination
export const getMachines = (page = 1, filters = {}) => async (dispatch) => {
    dispatch({ type: SET_LOADING_MACHINE, payload: true });
    
    try {
        let queryParams = '';
        if (filters) {
            Object.keys(filters).forEach((key, index) => {
                if (index === 0) {
                    queryParams += `?${key}=${filters[key]}`;
                } else {
                    queryParams += `&${key}=${filters[key]}`;
                }
            });
        }
        
        const separator = queryParams ? '&' : '?';
        const res = await axios.get(`/machines${queryParams}${separator}page=${page}`);
        
        dispatch({
            type: GET_MACHINES,
            payload: res.data,
        });
        dispatch({ type: SET_LOADING_MACHINE, payload: false });
    } catch (err) {
        console.error('Error fetching machines:', err);
        dispatch({ type: SET_LOADING_MACHINE, payload: false });
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load machines', 'danger'));
    }
};

// Get single machine
export const getMachine = (id) => async (dispatch) => {
    dispatch({ type: SET_LOADING_MACHINE, payload: true });
    
    try {
        const res = await axios.get(`/machines/${id}`);
        
        dispatch({
            type: GET_MACHINE,
            payload: res.data.data,
        });
        dispatch({ type: SET_LOADING_MACHINE, payload: false });
    } catch (err) {
        console.error('Error fetching machine:', err);
        dispatch({ type: SET_LOADING_MACHINE, payload: false });
        dispatch({
            type: MACHINE_ERROR,
            payload: err.response?.data,
        });
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load machine', 'danger'));
    }
};

// Get machine options for dropdowns
export const getMachineOptions = () => async (dispatch) => {
    try {
        const res = await axios.get('/machines/options');
        
        dispatch({
            type: 'GET_MACHINE_OPTIONS',
            payload: res.data,
        });
    } catch (err) {
        console.error('Error fetching machine options:', err);
        dispatch({
            type: 'GET_MACHINE_OPTIONS',
            payload: { machines: [] }, // Fallback to empty array
        });
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load machine options', 'danger'));
    }
};

// Set delete machine ID
export const setDeleteMachineId = (id) => async (dispatch) => {
    dispatch({
        type: SET_DELETE_MACHINE_ID,
        payload: id
    });
};

// Set update machine ID
export const setUpdateMachineId = (id) => async (dispatch) => {
    dispatch({
        type: SET_UPDATE_MACHINE_ID,
        payload: id
    });
};

// Add machine
export const addMachine = (formData) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.post('/machines', formData, config);

        dispatch(setAlert('Uskuna muvaffaqiyatli qo\'shildi!', 'success'));
        dispatch(getMachines()); // Refresh the list
        return true;
    } catch (err) {
        dispatch({
            type: MACHINE_ERROR,
            payload: err.response?.data,
        });
        dispatch(setAlert(err?.response?.data?.message || 'Uskuna qo\'shishda xatolik yuz berdi!', 'danger'));
        return false;
    }
};

// Clear errors
export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: 'CLEAR_MACHINE_ERRORS',
    });
};

// Get firm options for machine form
export const getFirmOptions = () => async (dispatch) => {
    try {
        const res = await axios.get('/firms/manager-options');
        
        dispatch({
            type: 'GET_FIRM_OPTIONS',
            payload: { data: res.data }, // Wrap in data object to match expected structure
        });
    } catch (err) {
        console.error('Error fetching firm options:', err);
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load firm options', 'danger'));
    }
};

// Get employee options for operators
export const getEmployeeOptions = () => async (dispatch) => {
    try {
        const res = await axios.get('/employees?is_all=true');
        
        dispatch({
            type: 'GET_EMPLOYEE_OPTIONS',
            payload: res.data,
        });
    } catch (err) {
        console.error('Error fetching employee options:', err);
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load employee options', 'danger'));
    }
};

// Get employee options by firm
export const getEmployeeOptionsByFirm = (firmId) => async (dispatch) => {
    try {
        const res = await axios.get(`/employees?is_all=true&firm_id=${firmId}`);
        
        dispatch({
            type: 'GET_EMPLOYEE_OPTIONS',
            payload: res.data,
        });
    } catch (err) {
        console.error('Error fetching employee options by firm:', err);
        dispatch(setAlert(err?.response?.data?.message || 'Failed to load employee options', 'danger'));
    }
};

// Update machine
export const updateMachine = (machineId, formData, currentPage = 1) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.put(`/machines/${machineId}`, formData, config);

        dispatch(setAlert('Uskuna muvaffaqiyatli tahrirlandi!', 'success'));
        dispatch(getMachines(currentPage)); // Refresh the list
        dispatch(setUpdateMachineId(null)); // Close the modal
        return true;
    } catch (err) {
        dispatch({
            type: MACHINE_ERROR,
            payload: err.response?.data,
        });
        dispatch(setAlert(err?.response?.data?.message || 'Uskuna tahrirlashda xatolik yuz berdi!', 'danger'));
        return false;
    }
};

// Delete machine
export const deleteMachine = (machineId, currentPage = 1) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        await axios.delete(`/machines/${machineId}`, config);

        dispatch(setAlert('Uskuna muvaffaqiyatli o\'chirildi!', 'success'));
        dispatch(getMachines(currentPage)); // Refresh the list
        dispatch(setDeleteMachineId(null)); // Close the modal
        return true;
    } catch (err) {
        dispatch({
            type: MACHINE_ERROR,
            payload: err.response?.data,
        });
        dispatch(setAlert(err?.response?.data?.message || 'Uskuna o\'chirishda xatolik yuz berdi!', 'danger'));
        return false;
    }
};

// Remove delete machine
export const removeDeleteMachine = () => async (dispatch) => {
    dispatch({
        type: REMOVE_DELETE_MACHINE,
    });
}; 